import { SidebarState } from '@components/v2/layout/AppTemplate/appTemplate.types';
import { createContext, useContext } from 'react';

interface AppTemplateContextValue {
  sidebarState: SidebarState;
  topSlotHeight: number;
}

export const AppTemplateContext = createContext<AppTemplateContextValue | null>(null);

export const useAppTemplateContext = (): AppTemplateContextValue => {
  const ctx = useContext(AppTemplateContext);
  if (!ctx) {
    throw new Error('useAppTemplateContext must be used within AppTemplate');
  }
  return ctx;
};

export const useTopSlotOffset = () => useContext(AppTemplateContext)?.topSlotHeight ?? 0;

export const useSidebarStateOrHidden = (): SidebarState =>
  useContext(AppTemplateContext)?.sidebarState ?? 'hidden';
